<script setup lang="ts">
/**
 * A labelled control.
 *
 * Exists so every field in the inspector has the same label treatment, the
 * same spacing and the same relationship between the label and what it
 * labels. Repeating that per field is how a panel ends up with six slightly
 * different label sizes.
 *
 * The label is a real `<label>` wrapping its control, so clicking it focuses
 * the control without anything needing an id.
 */
defineProps<{
  label: string
  /** Shown under the control, for a constraint or a consequence. */
  hint?: string
}>()
</script>

<template>
  <label class="field">
    <span class="b-label">{{ label }}</span>
    <slot />
    <span v-if="hint" class="field__hint">{{ hint }}</span>
  </label>
</template>

<style scoped>
.field {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.field__hint {
  color: var(--ink-faint);
  font-size: var(--text-xs);
  line-height: 1.45;
}
</style>
